export default "__VITE_ASSET__9d50cc74__"